
<div *ngIf="loader">
    <div id="global-loader">
        <img src="./assets/img/loaders/loader.svg" class="loader-img" alt="Loader">
    </div>
</div>
